// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application--wrap{min-height:unset}", "",{"version":3,"sources":["webpack://./src/component/sail/SailBatchUpdateModal.vue"],"names":[],"mappings":"AA4TA,qBACE,gBAAA","sourcesContent":[".v-application--wrap{min-height:unset}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
